/* eslint-disable max-len */
const required = 'This field is required'

export const ACCOUNT_CREATE_FORM_CONFIG = {
  firstName: {
    label: 'First Name',
    errorMessages: { required }
  },
  lastName: {
    label: 'Last Name',
    errorMessages: { required }
  },
  dateOfBirth: {
    label: 'Date of Birth',
    errorMessages: {
      required,
      dateInvalid: 'Date is invalid',
      dateOutOfRange: 'Date is unavailable',
      dob13: 'You are not eligible to create a SportsEngine account. Please ask your parent or guardian to create an account.'
    },
    yearRange: { future: 0, past: 100 }
  },
  canadianOptions: [{
    label: 'Select if you are a Canadian resident',
    value: true,
  }],
  communicationPrefs: {
    label: 'Communication Preferences',
    errorMessages: { required }
  },
  communicationPrefOptions: [
    {
      label: 'I would like to receive all communications related to the organizations I, or my dependents are registered with, required SportsEngine account updates, and SportsEngine content and news updates.',
      value: '1',
    },
    {
      label: 'I would like to only receive communication from the organizations I, or my dependents are registered with, and required SportsEngine account updates.',
      value: '0',
    }
  ],
  email: {
    label: 'Email',
    errorMessages: {
      required,
      email: 'Please enter a valid email'
    }
  },
  phone: {
    label: 'Phone',
    errorMessages: {
      required,
      phone10To12: 'Please enter a valid phone number'
    }
  }
}
